/**
 * Roles permissions:
 * SuperAdmin: 0
 * RegionalAdmin: 1
 * PromotionManager: 2
 * PrizeManager: 3
 * ReadOnly: 4
 * ===Admin & Operations roles will be removed in the future===
 * Admin: 0
 * Operations: 4
 */

export const rolesMap = {
    SuperAdmin: 0,
    RegionalAdmin: 1,
    PromotionManager: 2,
    PrizeManager: 3,
    ExportManager: 4,
    ReadOnly: 5,
    //Admin & Operations roles will be removed in the future
    Admin: 0,
    Operations: 6,
}
